export default "__VITE_ASSET__CMxxrip5__"